export default "__VITE_ASSET__DDv8FEb5__"